import React from "react";

function Resources() {
    return (
        <div className="detail-box">

<h3 align="center">Resources</h3>

<div className="home-category">Instagram</div>

<ul className="gallery mw-gallery-traditional">
<li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN Official Instagram" href="https://www.instagram.com/figpinofficial/" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Official Instagram" className="where-image" src="ig_figpin.png"/></a>
        <div className="pinname">FiGPiN Official Instagram</div>
    </div></li>
    <li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN.KiNGPiN Instagram" href="https://www.instagram.com/figpin.kingpin/" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN.KiNGPiN Instagram" className="where-image" src="ig_figpinkingpin.png"/></a>
        <div className="pinname">FiGPiN.KiNGPiN Instagram</div>
    </div></li>
    <li className="gallerybox">
        <div className="pinbox">
        <a title="figpin_mania Instagram" href="https://www.instagram.com/figpin_mania/" target="_blank" rel="noreferrer noopener">
        <img alt="figpin_mania Instagram" className="where-image" src="ig_figpinmania.png"/></a>
        <div className="pinname">figpin_mania Instagram</div>
    </div></li>

    <li className="gallerybox">
        <div className="pinbox">
        <a title="professor_figpin Instagram" href="https://www.instagram.com/professor_figpin/" target="_blank" rel="noreferrer noopener">
        <img alt="professor_figpin Instagram" className="where-image" src="ig_professorfigpin.png"/></a>
        <div className="pinname">professor_figpin Instagram</div>
    </div></li>

    <li className="gallerybox">
        <div className="pinbox">
        <a title="figpinupdates Instagram" href="https://www.instagram.com/figpinupdates/" target="_blank" rel="noreferrer noopener">
        <img alt="figpinupdates Instagram" className="where-image" src="ig_figpinupdates.png"/></a>
        <div className="pinname">figpinupdates Instagram</div>
    </div></li>
{/*
    <li className="gallerybox">
        <div className="pinbox">
        <a title="Levi K Instagram" href="https://www.instagram.com/levithecollector/" target="_blank" rel="noreferrer noopener">
        <img alt="Levi K Instagram" className="where-image" src="ig_levi.png"/></a>
        <div className="pinname">Levi K Instagram</div>
    </div></li>
    <li className="gallerybox"><div className="pinbox">
        <a title="FiGPiN FAN Instagram" href="https://www.instagram.com/figpinfan/" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN FAN Instagram" className="where-image" src="ig_figpinfan.png"/></a>
        <div className="pinname">FiGPiN FAN Instagram</div>
    </div></li>
    <li className="gallerybox"><div className="pinbox">
        <a title="FiGPiN Alerts Instagram" href="https://www.instagram.com/figpin_alerts/" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Alerts Instagram" className="where-image" src="ig_figpinalerts.png"/></a>
        <div className="pinname">FiGPiN Alerts Instagram</div>
    </div></li>
*/}
{/*
    <li className="gallerybox"><div className="pinbox">
        <a title="FiGPiN Unlocks Instagram" href="https://www.instagram.com/figpin_unlocks/" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Unlocks Instagram" className="where-image" src="ig_figpinunlocks.png"/></a>
        <div className="pinname">FiGPiN Unlocks Instagram</div>
    </div></li>
    */}
    {/*
    <li className="gallerybox"><div className="pinbox">
        <a title="FiGPiN Hunter Instagram" href="https://www.instagram.com/figpinhunter/" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Hunter Instagram" className="where-image" src="ig_figpinhunter.png"/></a>
        <div className="pinname">FiGPiN Hunter Instagram</div>
    </div></li>

    <li className="gallerybox"><div className="pinbox">
        <a title="im.toofu Instagram" href="https://www.instagram.com/im_toofu/" target="_blank" rel="noreferrer noopener">
        <img alt="im.toofu Instagram" className="where-image" src="ig_imtoofu.jpg"/></a>
        <div className="pinname">im_toofu Instagram</div>
    </div></li>

    <li className="gallerybox"><div className="pinbox">
        <a title="FiGPiN Gallery Instagram" href="https://www.instagram.com/figpingallery/" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Gallery Instagram" className="where-image" src="ig_figpingallery.jpg"/></a>
        <div className="pinname">FiGPiN Gallery Instagram</div>
    </div></li>

    <li className="gallerybox"><div className="pinbox">
        <a title="midnight.geek Instagram" href="https://www.instagram.com/midnight.geek/" target="_blank" rel="noreferrer noopener">
        <img alt="midnight.geek Instagram" className="where-image" src="ig_midnightgeek.jpg"/></a>
        <div className="pinname">midnight.geek Instagram</div>
    </div></li>    

    <li className="gallerybox"><div className="pinbox">
        <a title="nerds_that_collect Instagram" href="https://www.instagram.com/nerds_that_collect/" target="_blank" rel="noreferrer noopener">
        <img alt="nerds_that_collect Instagram" className="where-image" src="logo_nerds.png"/></a>
        <div className="pinname">nerds_that_collect Instagram</div>
    </div></li>  
    */}
</ul>

<div className="home-category">Discord</div>

<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><div className="pinbox">
        <a title="FiGPiN FANS Discord Group" href="https://discord.com/invite/figpinfans" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN FANS Discord Group" className="where-image" src="figpinfans.png"/></a>
        <div className="pinname">FiGPiN FANS Discord Group</div>
    </div></li>

    <li className="gallerybox">
        <div className="pinbox">
        <a title="Taggem Discord Group" href="https://discord.gg/DDGnmZH" target="_blank" rel="noreferrer noopener">
        <img alt="Taggem Discord Group" className="where-image" src="logo_taggem.png"/></a>
        <div className="pinname">Taggem Discord Group</div>
    </div></li>
    <li className="gallerybox"><div className="pinbox">
        <a title="Collect Awesome Enthusiasts Discord Group" href="https://discord.gg/gpeqeR3FC6" target="_blank" rel="noreferrer noopener">
        <img alt="Collect Awesome Enthusiasts Discord Group" className="where-image" src="logo_cae.png"/></a>
        <div className="pinname">Collect Awesome Enthusiasts Discord Group</div>
    </div></li>
</ul>

<div className="home-category">Facebook</div>

<ul className="gallery mw-gallery-traditional">
<li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN Official Facebook Page" href="https://www.facebook.com/figpinofficial" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Official Facebook Page" className="where-image" src="fb_figpin.png"/></a>
        <div className="pinname">FiGPiN Official Facebook Page</div>
    </div></li>
    <li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN Chasers Facebook Group" href="https://www.facebook.com/groups/2039479343013096" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Chasers Facebook Group" className="where-image" src="figpinchasers.png"/></a>
        <div className="pinname">FiGPiN Chasers Facebook Group</div>
    </div></li>

    <li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN Collectors Facebook Group" href="https://www.facebook.com/groups/644544292555415" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Collectors Facebook Group" className="where-image" src="figpincollectors.png"/></a>
        <div className="pinname">FiGPiN Collectors Facebook Group</div>
    </div></li>

    <li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN Buy/Sell/Trade Facebook Group" href="https://www.facebook.com/groups/600807137026219" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Buy/Sell/Trade Facebook Group" className="where-image" src="figpinbst.png"/></a>
        <div className="pinname">FiGPiN Buy/Sell/Trade Facebook Group</div>
    </div></li>

    <li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN Boosters Facebook Group" href="https://www.facebook.com/groups/243933580059775" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Boosters Facebook Group" className="where-image" src="figpinboosters.png"/></a>
        <div className="pinname">FiGPiN Boosters Facebook Group</div>
    </div></li>

    <li className="gallerybox">
        <div className="pinbox">
        <a title="WTFigpin Facebook Group" href="https://www.facebook.com/groups/704000377265946" target="_blank" rel="noreferrer noopener">
        <img alt="WTFigpin Facebook Group" className="where-image" src="wtfigpin.png"/></a>
        <div className="pinname">WTFigpin Facebook Group</div>
    </div></li>    
</ul>

<div className="home-category">YouTube</div>

<ul className="gallery mw-gallery-traditional">
    {/*
<li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN University YouTube Channel" href="https://www.youtube.com/channel/UC9yG2FTgbySIdOSWXBLRM7A/videos" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN University YouTube Channel" className="where-image" src="figpinu.png"/></a>
        <div className="pinname">FiGPiN University YouTube Channel</div>
    </div></li>
*/}
    <li className="gallerybox">
        <div className="pinbox">
        <a title="Curated Awesome YouTube Channel" href="https://www.youtube.com/channel/UCQWurWCZ_S9iatKrcpNfsOA" target="_blank" rel="noreferrer noopener">
        <img alt="Curated Awesome YouTube Channel" className="where-image" src="yt_curatedawesome.png"/></a>
        <div className="pinname">Curated Awesome YouTube Channel</div>
    </div></li>    
    <li className="gallerybox"><div className="pinbox">
        <a title="ImToofu YouTube Channel" href="https://www.youtube.com/channel/UCGlSUCK8Q2rNcg4kQtbPzBA" target="_blank" rel="noreferrer noopener">
        <img alt="ImToofu YouTube Channel" className="where-image" src="ig_imtoofu.jpg"/></a>
        <div className="pinname">ImToofu YouTube Channel</div>
    </div></li>    

    <li className="gallerybox">
        <div className="pinbox">
        <a title="WTFigpin YouTube Channel" href="https://www.youtube.com/channel/UCXaUsAeyY3f6BfoXL2muLCQ" target="_blank" rel="noreferrer noopener">
        <img alt="WTFigpin YouTube Channel" className="where-image" src="wtfigpin.png"/></a>
        <div className="pinname">WTFigpin YouTube Channel</div>
    </div></li>   

    <li className="gallerybox">
        <div className="pinbox">
        <a title="Vanessa Lima YouTube Channel" href="https://www.youtube.com/user/vanessaclima1995" target="_blank" rel="noreferrer noopener">
        <img alt="Vanessa Lima YouTube Channel" className="where-image" src="ig_vanessa.jpg"/></a>
        <div className="pinname">Vanessa Lima YouTube Channel</div>
    </div></li>    

    <li className="gallerybox">
        <div className="pinbox">
        <a title="Statue Fanatic YouTube Channel" href="https://www.youtube.com/c/STATUEFANATIC" target="_blank" rel="noreferrer noopener">
        <img alt="Statue Fanatic YouTube Channel" className="where-image" src="ig_statuefanatic.png"/></a>
        <div className="pinname">Statue Fanatic YouTube Channel</div>
    </div></li>    
</ul>

<div className="home-category">TikTok</div>

<ul className="gallery mw-gallery-traditional">
<li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN Official TikTok" href="https://www.tiktok.com/@figpinofficial" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Official TikTok" className="where-image" src="logo_figpin.png"/></a>
        <div className="pinname">FiGPiN Official TikTok</div>
    </div></li>
   {/*
<li className="gallerybox"><div className="pinbox">
        <a title="FiGPiN FAN TikTok" href="https://www.tiktok.com/@figpinfan" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN FAN TikTok" className="where-image" src="ig_figpinfan.png"/></a>
        <div className="pinname">FiGPiN FAN TikTok</div>
    </div></li>
*/}
</ul>

<div className="home-category">Other</div>

<ul className="gallery mw-gallery-traditional">
<li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN Official Blog" href="https://www.figpin.com/blog/news" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Official Blog" className="where-image" src="logo_figpin.png"/></a>
        <div className="pinname">FiGPiN Official Blog</div>
    </div></li>
    <li className="gallerybox">
        <div className="pinbox">
        <a title="FiGPiN Subreddit" href="https://reddit.com/r/figpin" target="_blank" rel="noreferrer noopener">
        <img alt="FiGPiN Subreddit" className="where-image" src="reddit.png"/></a>
        <div className="pinname">FiGPiN Subreddit</div>
    </div></li>
{/*
    <li className="gallerybox">
        <div className="pinbox">
        <a title="Pin Hobby FiGPiN Fan Website" href="https://pinhobby.com/" target="_blank" rel="noreferrer noopener">
        <img alt="Pin Hobby FiGPiN Fan Website" className="where-image" src="pinhobby.png"/></a>
        <div className="pinname">Pin Hobby FiGPiN Fan Website</div>
    </div></li>

    <li className="gallerybox">
        <div className="pinbox">
        <a title="Hero Complex (Displays)" href="https://www.herocomplexdisplays.com/collections/figpin" target="_blank" rel="noreferrer noopener">
        <img alt="Hero Complex (Displays)" className="where-image" src="logo_herocomplex.png"/></a>
        <div className="pinname">Hero Complex (Displays)</div>
    </div></li>
*/}
    <li className="gallerybox">
        <div className="pinbox">
        <a title="Display Geek (Displays)" href="https://displaygeek.com/products/figbox-black-display-case-for-figpin-wall-mountable-stackable-enamel-pin-shelf-corrugated-cardboard" target="_blank" rel="noreferrer noopener">
        <img alt="Display Geek (Displays)" className="where-image" src="logo_displaygeek.png"/></a>
        <div className="pinname">Display Geek (Displays)</div>
    </div></li>

    <li className="gallerybox">
        <div className="pinbox">
        <a title="Kollector Protector (Cases)" href="https://kollectorprotector.com/collections/figpin-acrylic-cases/Figpin" target="_blank" rel="noreferrer noopener">
        <img alt="Kollector Protector (Cases)" className="where-image" src="logo_kollectorprotector.png"/></a>
        <div className="pinname">Kollector Protector (Cases)</div>
    </div></li>

    <li className="gallerybox">
        <div className="pinbox">
        <a title="EcoTEK Protectors (Cases)" href="https://www.ecotek-protectors.com/collections/figpin-protectors" target="_blank" rel="noreferrer noopener">
        <img alt="EcoTEK Protectors (Cases)" className="where-image" src="logo_ecotek.png"/></a>
        <div className="pinname">EcoTEK Protectors (Cases)</div>
    </div></li>

      </ul>

        </div>
    );
}

export default Resources;


